import { render } from "./StartAll.vue?vue&type=template&id=cf967ff0"
import script from "./StartAll.vue?vue&type=script&lang=js"
export * from "./StartAll.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__